const Form075TC = {
    stepName: {
        importantNotes: "重要事項",
        workflow: "申請流程",
        information: "NAC20{{schoolyear}}",
        studentInformation: "附表NAC-1",
        confirmation: "確認",
    },
    workflow: {
        title1: "申請流程",
        title2: "可執行的動作",
        title3: "備註",
        tr1: {
            cell1: "(1) 申請人",
            cell2: [
                "填寫申請表；",
                "在螢幕上預覽申請摘要及學生資料（如適用），提交申請表至第一審批人；及",
                "提交後，可檢視申請表的 PDF。",
            ],
            cell3: "如申請人希望在檢視 PDF 後，再向審批人提交申請，請設定申請人與第一審批人為同一人。",
        },
        tr2: {
            cell1: "(2) 第一審批人",
            cell2: [
                "檢視申請表的 PDF；",
                "在螢幕上預覽/修改申請表內容，並提交申請表至第二審批人；或",
                "把申請表退回申請人。",
            ],
            cell3: "在系統預設下，如第一審批人與第二審批人相同時（通常為校長），有關人員必須分別以第一審批人與第二審批人身份提交表格（共 2 次），表格才能提交至教育局。",
        },
        tr3: {
            cell1: "(3) 第二審批人",
            cell2: [
                "檢視申請表的 PDF；",
                "在螢幕上預覽/修改申請表內容，簽署後提交申請表至教育局；或",
                "把申請表退回申請人。",
            ],
            cell3IsGovernmentSchool:
                "如官立學校校長未能按要求以電子方式簽署電子表格，請設定校長為第二審批人，以提交電子表格至教育局。同時，校長應在列印本上簽署，並連同相關證明文件（如適用），一併提交予教育局。",
            cell3IsNonGovernmentSchool:
                "如非官立學校校監未能按要求以電子方式簽署電子表格，請設定校長為第二審批人，以提交電子表格至教育局。同時，校監應在列印本上簽署，並連同相關證明文件（如適用），一併提交予教育局。",
        },
        tr4: {
            cell1: "(4) 教育局",
            cell2: ["接收申請；或", "把申請表退回申請人。"],
            cell3: "教育局會按需要聯絡學校。",
        },
        note: "如學校希望修改上述「申請流程」，請向學校行政主戶（MSA）（例如貴校的學校行政主任）查詢。他／她可參考已上載於本局網站（<a href='https://www.edb.gov.hk/tc/student-parents/newly-arrived-children/sbss/index.html' target='_blank'>https://www.edb.gov.hk/tc/student-parents/newly-arrived-children/sbss/index.html</a>）的「電子申請表—常見問題及填寫指引」（有關「於電子表格遞交系統委派指定『申請人』及『審批人』」），以便修改相關設定。",
        workflowConfirm: "本人已知悉上述申請流程。",
    },
    label: {
        SBSSGrant: "校本支援計劃津貼",
        detailOfSBSSGrant: "校本支援計劃津貼詳情",
        note: "收集個人資料的目的",
        schoolNo: "學校編號",
        location: "學校位置標識",
        session: "授課時間",
        sessionOp: {
            am: "上午校",
            pm: "下午校",
            wholeDay: "全日制",
        },
        num: "號數",
        strn: "學生編號",
        typeOfStudent: "學生類別",
        typeOp: {
            NAC: "內地新來港兒童",
            NCS: "非華語兒童",
            Returnee: "回流兒童",
        },
        nameEn: "學生姓名(英文)",
        nameCn: "學生姓名(中文)",
        sex: "性別",
        sexOp: {
            Male: "男",
            Female: "女",
        },
        birth: "出生日期",
        level: "入讀班級",
        firstDay: "首天上課日期",
        dateOfArrival:
            "到港/回流日期（以單程證／護照上入境處蓋印或家長聲明的日期為準）",
        dateOfArrival2: "註: 屬香港出生的跨境學生，請填「不適用(跨境學生)」",
        hkBorn: "香港出生",
        crossBoundary: "跨境學生",
        yesOrNo: {
            yes: "是",
            no: "否",
        },
        schoolName: "學校名稱",
        telNo: "電話號碼",
        faxNo: "傳真號碼",
        nameOfContactPerson: "負責教師/職員姓名",
        postOfContactPerson: "負責教師/職員職位",
        schoolLevel: "教學程度",
        schoolLevelOption: {
            primary: "小學",
            secondary: "中學",
        },
        supervisorOrPrincipal: "校監/校長",
        supervisorOrPrincipalOption: {
            supervisor: "校監",
            principal: "校長",
        },
        applyTitle: "請選擇",
        formType: {
            schoolBasedSupportSchemeGrant:
                "申請校本支援計劃津貼 ({{schoolyear}} 年度)",
            grantSummaryAndAdvancePayment: "校本支援計劃津貼申請摘要及預支津貼",
        },
        supervisorOrSchoolHeadName: "校監/校長(如申請來自官立學校)姓名",
        supervisorName: "校監姓名",
        schoolHeadName: "校長姓名",
        submitType: "我想提交這個申請表",
        submitTypeOption: {
            iamSmart: "使用我的“iAM Smart+”賬戶",
            scannedSignature: "使用我的掃描簽名",
            electronicSignature: "使用電子簽名",
        },
        titleList: [
            "1. 按{{schoolyear}}學年實際入讀的有關學童人數申請該津貼",
            "2. 申請{{schoolYearForAdvancePayment}}學年的預支津貼",
            "3. 本校資料如下：",
        ],
        informationTitle: "申請摘要及預支津貼",
        formTextDeclare: "本校申請該津貼的學童人數如下：",
        noteSuperScript: "註",
        formText1a: "於{{schoolyear}}學年共",
        formText1b:
            "名有關學童入讀本校，本人為這些學生申請該津貼。本人謹盡己所知，特此證明，夾附的申請書所提供及填報的資料均真實無訛，同時，本校已為附表NAC-1上所列的學生提供適當的支援服務。",
        formText1c: "註：在完成第4步後，由系統填寫。",
        formText2a:
            "本人申請將於{{schoolYearForAdvancePayment}}學年發放的預支「校本支援計劃津貼」。本校",
        formText2b: "預計",
        formText2c: "{{periodForAdvancePayment}}期間，將有約",
        formText2d: "名有關學童入讀。",
        date: "日期",
        defaultSetting: "預設設定：學生資料",
        appendix: "附表NAC-1：學生資料",
        levelOptions: {
            p1: "小一",
            p2: "小二",
            p3: "小三",
            p4: "小四",
            p5: "小五",
            p6: "小六",
            s1: "中一",
            s2: "中二",
            s3: "中三",
            s4: "中四",
            s5: "中五",
            s6: "中六",
        },
        beforePrintIsGovernmentSchool:
            "請提醒貴校的第二審批人簽署及向教育局提交申請。一般而言，校長為官立學校的第二審批人。",
        beforePrintIsNotGovernmentSchool:
            "請提醒貴校的第二審批人簽署及向教育局提交申請。一般而言，校監為非官立學校的第二審批人。",
        printPdfTips:
            "請將申請表列印本，連同有關兒童（申請{{schoolyear}}學年津貼）的證明文件，一併於<b><u>{{note}}</u></b>，以郵寄方式或派專人送交至香港灣仔皇后大道東213號胡忠大廈14樓1424室予教育局學位安排及支援組辦理。",
        printPdfTips2:
            "如果校監/校長尚未在表格使用電子簽名，請在列印本上簽名。",
        enteredStudents:
            "你已經輸入了{{enteredStudents}}位學生的資料，請定時儲存表格。",
        beforeRefIsGovernmentSchool:
            "如官立學校校長未能按要求以電子方式簽署電子表格，校長應在列印本上簽署，並連同相關證明文件（如適用），一併提交予教育局。",
        beforeRefIsNotGovernmentSchool:
            "如非官立學校校監未能按要求以電子方式簽署電子表格，校監應在列印本上簽署，並連同相關證明文件（如適用），一併提交予教育局。",
    },
    button: {
        addStudent: "新增一位學生",
        addStudentWithDefaults: "新增一位學生(含預設值)",
        add5StudentsWithDefaults: "新增五位學生(含預設值)",
    },
    popUp: {
        next: {
            msg: "提交沒有{{schoolyear}}學年學生的申請?",
            confirm: "確認",
            cancel: "取消",
        },
        alert: {
            returnee:
                "學校請<b><u>同時</b></u>提供學生父親<b><u>及</b></u>母親的<b><u>香港永久性居民身份證</b></u>副本作為回流兒童申請的其中一項證明文件。如未能提供有關文件，學校可檢視有關學生是否符合「內地新來港兒童」或「非華語兒童」的準則及條件，而作出申請。",
        },
    },
    note: {
        note1: {
            title: `1.	你在本表格及附表提供的個人資料，會供教育局用於以下一項或多項用途：`,
            subtitle: "收集個人資料的目的",
            content1:
                "(a)	處理、核實、審核資格及查證就新來港兒童校本支援計劃津貼的申請；",
            content2:
                "(b)	就上文(a)項所述申請的處理、核實、審核資格及查證，將個人資料與政府相關政策局／部門資料庫進行核對；",
            content3:
                "(c)	將個人資料與教育局資料庫進行核對，以核實／更新教育局的記錄；以及",
            content4: "(d)	編製統計資料、研究及政府刊物。",
        },
        note2: {
            title: `2.	你必須按本表格及附表的要求及於本局處理本表格及附表的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理有關申請。`,
        },
        note3: {
            title: `3.	你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：`,
            subtitle: "可獲轉移資料者",
            content1: "(a)	政府其他政策局及部門，以用於上文第1段所述的用途；",
            content2:
                "(b)	與本表格及附表相關的學校，以用於上文第1段所述的用途；",
            content3: "(c)	你曾就披露個人資料給予訂明同意；以及",
            content4:
                "(d)	根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
        },
        note4: {
            title: `4.	你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向助理教育主任(學位安排及支援)31提出(地址：香港灣仔皇后大道東213號胡忠大廈14樓1424室或電郵：`,
            subtitle: "查閱個人資料",
        },
    },
    email: "aeops31@edb.gov.hk",
    emailEnd: ")。",
    errorMsg: {
        alphabetsOnly: "字符類型只允許 (英文)",
        chineseOnly: "字符類型只允許 (中文)",
        arrayRule: "學生總數必須與第1項填寫的數量相同",
        maxNum: "最大學生人數為{{max}}",
        minNum: "最少學生人數為{{min}}",
        dateRule: "請選擇不晚於{{targetDate}}的日期",
        least5YearsBefore: "提交時學生必須年滿5歲",
        duplicatedSTRN:
            "{{duplicatedOrder}}的學生編號(STRN)相同，請檢查並更正。",
        within1Year: "到港日期與首天上課日期之間的時間間隔必須在1年內。",
        arrivalAfterBirth: "入境日期必須遲於出生日期。",
    },
};
export default Form075TC;
